import { CompaniesPageCompanyFragment } from 'generated/graphql';

export const parseCompanies = (
  companies: CompaniesPageCompanyFragment[],
  search: string
) => {
  if (!search) {
    return [...companies].sort((a, b) =>
      a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1
    );
  }

  return companies
    .filter(company => {
      return company.name
        .toLocaleLowerCase()
        .includes(search.toLocaleLowerCase());
    })
    .sort((a, b) =>
      a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1
    );
};
